<template>
  <section class="vh-100 login-content">
    <div class="container py-5 h-100 ">
      <div class="row d-flex align-items-center justify-content-center h-100">
        <div class="col-md-8 col-lg-7 col-xl-6">
          <img
            src="https://img.freepik.com/free-vector/enter-otp-concept-illustration_114360-7867.jpg?t=st=1654401030~exp=1654401630~hmac=971328ed769eda6a70a1c65434c468589642eda2782ea8a1db3fac789bf81040&w=1060"
            class="img-fluid"
            alt="Phone image"
          />
        </div>
        <div class="col-md-7 col-lg-5 col-xl-5 offset-xl-1">
          <form @submit="forgetPassword" class="pt-2 pl-2 pr-8">
            <div class="form-group">
              <label>Mail Adresinize Gelen Doğrulama Kodunu Giriniz</label>
              <input
                type="text"
                class="form-control"
                v-model="activation_code"
                required
              />
            </div>
          </form>
          <p class="text-center">
            <button class="btn btn-primary mt-4 py-2" @click="forgetPassword()">
              Devam Et
            </button>
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import store from "../../store";
import axios from "axios";
export default {
  name: "ForgetPassword",
  props: ["baseURL"],
  data() {
    return {
      email: null,
      activation_code: null,
    };
  },
  methods: {
    forgetPassword() {
      const emails = {
        email: this.email,
        activation_code: this.activation_code,
      };

      var url = store.state.base_url + "User/activationController.php?key=123";
      axios
        .post(url, JSON.stringify(emails))
        .then((res) => {
          localStorage.setItem("activation", res.data);
            if (res.data) {
              setTimeout(this.$router.push({ name: "checkPassword" }), 1500);
            }
        })
        .catch((err) => {
          swal({
            text: "Hatalı Kullanıcı Adı Veya Şifre",
            icon: "error",
            closeOnClickOutside: false,
          });
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.email = localStorage.getItem("email");
    localStorage.removeItem("token");
    localStorage.removeItem("admin_token");
    localStorage.removeItem("key");
    localStorage.removeItem("admin_id");
    this.loading = false;
    this.password = null;
  },
};
</script>

<style>
.not-found {
  text-align: center;
}
.not-found h2 {
  font-size: 150px;
  margin-top: 30px;
}
.not-found h3 {
  font-size: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/password/PasswordActivation.vue